var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 19.5H3V4.5", stroke: "#303030", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M19.5 6L12 13.5L9 10.5L3 16.5", stroke: "#303030", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M19.5 9.75V6H15.75", stroke: "#303030", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});